// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"c36494b7","66":"67d42f70","143":"da0db23d","164":"60d45fc2","238":"ec898b3a","251":"60d74b84","377":"452421c2","517":"98af9425","720":"fac433e7"}[chunkId] + ".css";
};